import Swal from "sweetalert2";

export default function notificationError(response: any) {
    Swal.fire({
        icon: "error",
        // title: "Error",
        text: response?.data?.message || (response?.data?.errors ? response?.data?.errors[0]?.errorMessage : null) || response?.statusText || response?.message || response
    })
}